'use client';

import { forwardRef } from 'react';
import { FilledInputProps, InputProps, OutlinedInputProps, styled, TextField, TextFieldProps, useTheme } from '@mui/material';
import deepmerge from 'deepmerge';

type BaseTextFieldProps = TextFieldProps & { maxLength?: number };

const BaseTextField = forwardRef<HTMLInputElement, BaseTextFieldProps>((props, ref) => {
    const theme = useTheme();
    const { size = 'small', fullWidth = true, type = 'text', maxLength, inputProps = {}, InputProps = {}, sx = {}, ...other } = props;

    return (
        <TextField
            ref={ref}
            fullWidth={fullWidth}
            size={size}
            type={type}
            autoComplete="off"
            sx={{

                '.MuiFormHelperText-root': {
                    paddingTop: 3.55,
                    paddingX: 4,
                    m: 0,
                },

                '.MuiOutlinedInput-root': {
                    p: '16px 14px',
                    // border: '1px solid #EEE',
                    background: theme.palette.grayscale.gray01,
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid #000',
                    },
                },
                '.MuiOutlinedInput-notchedOutline': {
                    border: '1px solid #EEE',
                },
                '.MuiOutlinedInput-input': {
                    padding: 0,
                },
                ...sx,
            }}
            inputProps={maxLength ? { maxLength: maxLength, ...inputProps } : { ...inputProps }}
            InputProps={deepmerge<Partial<FilledInputProps> | Partial<OutlinedInputProps> | Partial<InputProps>>(
                {
                    sx: {
                        ...theme.typography.h2_14Medium,
                        color: theme.palette.grayscale.gray07,
                        height: props.multiline ? 'auto' : '46px',
                        py: 0,
                        input: {
                            '&:focus': {
                                color: theme.palette.text.primary,
                            },
                        },
                    },
                },
                InputProps
            )}
            {...other}
        />
    );
});

BaseTextField.displayName = 'BaseTextField';

export default BaseTextField;
